import React, { FC } from "react";
import { Field } from "react-final-form";
import { Grid } from "@material-ui/core";
import BootstrapInput from "../../../../../components/BootstrapInput";
import FieldsGroupLabel from "../common/FieldsGroupLabel";
import { ICourseComponentProps } from "../../../types";

interface IAccommodationFeesProps extends ICourseComponentProps {
  residenceRequired?: boolean;
  homestayRequired?: boolean;
}

const AccommodationFees: FC<IAccommodationFeesProps> = ({
  fieldsGroupName,
  residenceRequired = false,
  homestayRequired = false,
}) => (
  <div>
    <FieldsGroupLabel
      label="Accommodation Fees"
      className="fields-group-label"
    />
    <Grid container spacing={3}>
      <Grid item xs={12} sm={12} md={4}>
        <Field
          required={residenceRequired}
          disabled={!residenceRequired}
          placeholder={residenceRequired ? "Amount" : ""}
          fullWidth
          type="text"
          label="Residence"
          name={`${fieldsGroupName}.residenceAmount`}
          component={BootstrapInput}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={4}>
        <Field
          required={homestayRequired}
          disabled={!homestayRequired}
          placeholder={homestayRequired ? "Amount" : ""}
          fullWidth
          type="text"
          label="Homestay"
          name={`${fieldsGroupName}.homestayAmount`}
          component={BootstrapInput}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={4}>
        <Field
          fullWidth
          type="text"
          label="Insurance"
          placeholder="Amount"
          name={`${fieldsGroupName}.insuranceAmount`}
          component={BootstrapInput}
        />
      </Grid>
    </Grid>
  </div>
);

export default React.memo(AccommodationFees);
